(function packagingProminenceInit() {
 var $ = window.jQuery;
 if (!$) { setTimeout(packagingProminenceInit, 50); return; }


 var ppEl = document.querySelector('.packaging-prominence');
 var ccproducthandle = ppEl ? ppEl.getAttribute('data-product-handle') : '';
 var ccproducturl = '/products/' + ccproducthandle;
 var variantMap = {};


 if (ccproducthandle === 'santa-pants-pecan-gift' || ccproducthandle === 'gift-card') {
   $('.packaging-prominence').hide();
   return;
 }


 function createProductCard() {
   return $('<div class="variant-card">' +
     '<div class="radio-option"></div>' +
     '<div class="radio-content">' +
       '<div class="variant-img"><img src="" alt="product image" loading="lazy"></div>' +
       '<div class="variant-title"></div>' +
       '<div class="variant-price"></div>' +
       '<div class="price-per-unit"></div>' +
     '</div></div>');
 }


 function formatPrice(pricePerUnit, moneyFormat) {
   if (!moneyFormat) return '';
   var formattedPrice = pricePerUnit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
   return moneyFormat.replace(/\{\{amount[^\}]*\}\}/, formattedPrice);
 }


 function getMoneyFormat() {
   return new Promise(function(resolve) {
     var getFmt = function() {
       return (window.mwFeesConfig && window.mwFeesConfig.money_format) ||
              (window.theme && window.theme.moneyFormat);
     };
     var immediate = getFmt();
     if (immediate) { resolve(immediate); return; }
     var i = setInterval(function() {
       var fmt = getFmt();
       if (fmt) { clearInterval(i); resolve(fmt); }
     }, 100);
   });
 }


 function fetchProductInfo() {
   fetch(ccproducturl + '.js')
     .then(function(res) { return res.json(); })
     .then(function(data) {
       var variants = data.variants;
       var moneyFormatPromise = getMoneyFormat();
       variants.forEach(function(v, idx) {
         var prdinfo = createProductCard();
         var cctitle = v.title;
         var ccprice = v.price;
         var vid = v.id;
         variantMap[String(vid)] = { option1: v.option1, option2: v.option2, option3: v.option3 };
         var quantity = 1;
         var unitType = '';
         var ccproductname = $('.main-content .product-single__meta .product-single__title').text().trim().toLowerCase();


         if (cctitle.includes('lb') && cctitle.includes('CASE')) {
           // Variant title itself says e.g. "2 lb (CASE of 4)" — this must
           // win over the ccproductname.includes('lb') branch below, which
           // otherwise fires first for every variant whenever the PRODUCT
           // title also happens to contain "lb" (e.g. "Seventh Heaven - 2
           // lb Gift Tin"), locking quantity to the product's base lb size
           // and never reaching the case-multiplier math for this variant.
           // Read the case count from "CASE of N" explicitly instead of assuming
           // it's whichever number happens to appear last in the title — that
           // assumption broke price-per-lb for variants where the lb size (not
           // the case count) is the last digit, e.g. "CASE of 5 - 2 lb".
           var caseOfMatch = cctitle.match(/CASE\s+of\s+(\d+)/i);
           var caseCount = caseOfMatch ? parseInt(caseOfMatch[1], 10) : 1;
           var caseLbMatch = cctitle.match(/(\d+(?:\.\d+)?)\s*lbs?/i);
           unitType = 'lb';
           quantity = caseCount * (caseLbMatch ? parseFloat(caseLbMatch[1]) : 1);
         } else if (cctitle.includes('Jar')) {
           var jarMatch = cctitle.match(/(\d+)\s*Jars?/);
           var ozMatch = cctitle.match(/(\d+)\s*oz?/);
           if (jarMatch) { quantity = parseInt(jarMatch[1], 10); unitType = 'jar'; }
           else if (ozMatch) { quantity = parseInt(ozMatch[1], 10); unitType = 'piece'; }
         } else if (cctitle.includes('lb') && cctitle.includes('pcs)')) {
           var lb = '', pc = '';
           var temp = cctitle.split(' ');
           temp = temp.map(function(x) { return x.trim().replace('(', '').replace(')', ''); });
           temp.forEach(function(val, indx) {
             if (temp[indx + 1] === 'lb.' || temp[indx + 1] === 'lb') lb = val.replace(/[^0-9/]/gi, '');
             if (temp[indx + 1] === 'pcs') pc = Number(val.replace(/[^0-9]/gi, ''));
             if (val.toLowerCase() === 'case' && temp.length > indx + 2 && temp[indx + 1].toLowerCase() === 'of') {
               var caseQty = Number(temp[indx + 2].replace(/[^0-9]/gi, ''));
               if (!isNaN(caseQty)) pc = caseQty * pc;
             }
           });
           if (lb === '1/2') lb = 0.5;
           lb = Number(lb);
           if (ccproductname.includes('gift box')) { quantity = pc; unitType = 'each'; }
           else if (pc) { quantity = pc; unitType = 'piece'; }
         } else if (cctitle.includes('lb') || cctitle.includes('lb.')) {
           // Checked before the ccproductname.includes('lb') fallback below —
           // otherwise a product title that happens to mention a base/default
           // lb size (e.g. "... 30 lb Boxes") hijacks every variant on that
           // product, including ones with their own different total weight
           // in the variant title itself, e.g. "150 lbs. (5 x 30 lb. Boxes)"
           // was being priced as if it were only 30 lb.
           var ccnewlbmatch = cctitle.match(/(\d+)\s*oz/);
           var ccnewcapmatch = cctitle.match(/(\d+)\s*OZ/);
           var match = cctitle.match(/\d+/g);
           var cccasematch = match ? match[match.length - 1] : null;
           var lbMatch = cctitle.match(/(\d+(?:\.\d+)?)\s*lbs?/i);
           if (ccnewlbmatch) { quantity = parseInt(ccnewlbmatch[1], 10); unitType = 'lb'; }
           else if (ccnewcapmatch) { quantity = parseInt(ccnewcapmatch[1], 10); unitType = 'lb'; }
           else if (lbMatch) {
             if (cctitle.includes('gallon') || cctitle.includes('gal')) { unitType = 'lb'; quantity = parseFloat(lbMatch[1]); }
             else if (cctitle.includes('CASE')) { unitType = 'lb'; quantity = cccasematch * parseInt(lbMatch[1], 10); }
             else { unitType = 'lb'; quantity = parseFloat(lbMatch[1]); }
           }
         } else if (ccproductname.includes('lb')) {
           var lbprdnameMatch = ccproductname.match(/(\d+)\s*lb/);
           unitType = 'lb';
           quantity = parseInt(lbprdnameMatch[1], 10);
         } else if (ccproductname.includes('bundles')) {
           unitType = 'bundle';
         } else if (cctitle.includes('Roll')) {
           var rollMatch = cctitle.match(/(\d+)\s*Log?/i);
           if (rollMatch) { quantity = parseInt(rollMatch[1], 10); unitType = 'each'; }
         } else if (cctitle.includes('Bag')) {
           var bagMatch = cctitle.match(/(\d+)\s*oz?/i);
           var bagMatchnew = cctitle.match(/(\d+)\s*bag?/i);
           if (bagMatch) { quantity = parseInt(bagMatch[1], 10); unitType = 'lb'; }
           else if (bagMatchnew) { quantity = parseInt(bagMatchnew[1], 10); unitType = 'bag'; }
         } else if (cctitle.includes('Pie')) {
           unitType = 'pie';
           if (cctitle.includes('One')) quantity = '1';
           else if (cctitle.includes('Two')) quantity = '2';
           else if (cctitle.includes('Three')) quantity = '3';
           else quantity = parseInt(cctitle[1], 10);
         } else if (cctitle.includes('Tin')) {
           var tinMatch = cctitle.match(/(\d+)\s*oz?/i);
           if (tinMatch) { quantity = parseInt(tinMatch[1], 10); unitType = 'piece'; }
         } else if (cctitle.includes('Treat')) {
           var treatMatch = cctitle.match(/(\d+)\s*Treat?/i);
           if (treatMatch) { quantity = parseInt(treatMatch[1], 10); unitType = 'piece'; }
         } else if (cctitle.includes('Combo. Chocolate')) {
           var boxMatchChoc = cctitle.match(/(\d+)\s*boxes?/i);
           if (boxMatchChoc) { quantity = parseInt(boxMatchChoc[1], 10) * 12; unitType = 'piece'; }
           else { quantity = '12'; unitType = 'piece'; }
         } else if (cctitle.includes('Combo.')) {
           var boxMatchCombo = cctitle.match(/(\d+)\s*boxes?/i);
           if (boxMatchCombo) { quantity = parseInt(boxMatchCombo[1], 10); unitType = 'piece'; }
           else { unitType = 'piece'; }
         } else if (cctitle.includes('tart')) {
           var tartMatch = cctitle.match(/(\d+)\s*tart?/i);
           if (tartMatch) { quantity = parseInt(tartMatch[1], 10); unitType = 'tart'; }
           else { unitType = 'pies'; }
         } else if (cctitle.includes('Box')) {
           var number = cctitle.match(/\d+/);
           var quantityval;
           unitType = 'pie';
           if (cctitle.includes('One')) quantityval = '1';
           else if (cctitle.includes('Two')) quantityval = '2';
           else if (cctitle.includes('Three')) quantityval = '3';
           else quantityval = '1';
           if (number) quantity = quantityval * number[0];
           else quantity = quantityval;
         }


         var pricePerUnits;
         var bagMatchOz = cctitle.match(/(\d+)\s*oz?/i);
         if (bagMatchOz) { pricePerUnits = (ccprice / quantity / 100) * 16; }
         else { pricePerUnits = ccprice / quantity / 100; }


         moneyFormatPromise.then(function(moneyFormat) {
           var formattedPrice = formatPrice(pricePerUnits, moneyFormat);
           prdinfo.find('.variant-title').text(cctitle);
           prdinfo.attr('data-variant-id', vid);
           var ccfirstprice = v.price / 100;
           var formattedfirstPrice = formatPrice(ccfirstprice, moneyFormat);
           prdinfo.find('.variant-price').text(formattedfirstPrice);
           if (quantity > 1) {
             prdinfo.find('.price-per-unit').html('(<b>' + formattedPrice + '</b> /' + unitType + ')');
           } else if (quantity == '1' && cctitle.includes('USD')) {
             prdinfo.find('.price-per-unit').html('(<b>' + formattedPrice + '</b>)');
           } else if (quantity == 1 || quantity === '') {
             prdinfo.find('.price-per-unit').html('(<b>' + formattedPrice + '</b> /' + unitType + ')');
           }
           if (unitType === '') {
             var ccproductnameCheck = $('.product-single__meta .product-single__title').text().trim();
             if (ccproductnameCheck.includes('Bag')) {
               var ccunittype = prdinfo.find('.price-per-unit').text().trim();
               prdinfo.find('.price-per-unit').text(ccunittype.replace('/', '/bag'));
             } else {
               prdinfo.find('.price-per-unit').addClass('bundle');
             }
           }
           prdinfo.find('.variant-img img').attr('src', v.featured_image ? v.featured_image.src : '');
           var ccPopularIds = ["21619910574140","21619991183420","21620088373308","21624867029052","21624896684092","44249216712953","21625033785404","21625052725308","21625122848828","21625177178172","21625281052732","35212081201307","21625926418492","35212103942299","21625944637500","35212191072411","35212210700443","21625976422460","35212018057371","21625992839228","35212143853723","21626042286140","29495732469820","21628596486204","21628920463420","21629157081148","21629171433532","21629305978940","33448873820291","35212052594843","22501504712764","43426171519225","34848520274075","35873521795227","36270920564891","41295153823899","44484544364793"];
           if (ccPopularIds.indexOf(String(vid)) !== -1) {
             prdinfo.prepend('<div class="popular-badge"><span class="badge-star">&#9733;</span> Very Popular</div>');
           }
           $('.packaging-items').append(prdinfo);
         });
       });
     });
 }


 fetchProductInfo();


 var cclabeltext = $('.selector-wrapper > label').text().trim();
 if (!$('.selector-wrapper > label').length) {
   $('.packaging-prominence').hide();
 }
 if (cclabeltext === 'Package') {
   $('.packaging-wrap label span').text('Packaging');
 } else if (cclabeltext === 'Size') {
   $('.packaging-wrap label span').text('Sizing');
 }


 function ccGetOptionsintial() {
   $(document).find('.product-form__variants.no-js').each(function() {
     var ccvalidx = this.selectedIndex;
     var ccval = $(document).find('.product-form__variants.no-js option').eq(ccvalidx).text().trim();
     $('.packaging-prominence .variant-card').each(function() {
       var ccOptVal = $(this).find('.variant-title').text().trim();
       if (ccval === ccOptVal) {
         $('.packaging-prominence .variant-card.radio-active').removeClass('radio-active');
         $(this).addClass('radio-active');
       }
     });
   });
 }


 setTimeout(ccGetOptionsintial, 2000);


 function ccoptionclick(ccOptVal) {
   var vdata = variantMap[String(ccOptVal)];
   if (!vdata) return;
   var selectors = $(document).find('.selector-wrapper .single-option-selector');
   var cclength = selectors.length;
   if (cclength >= 1) selectors.eq(0).val(vdata.option1).trigger('change');
   if (cclength >= 2) selectors.eq(1).val(vdata.option2).trigger('change');
   if (cclength >= 3) selectors.eq(2).val(vdata.option3).trigger('change');
 }


 $(document).on('click', '.packaging-prominence .variant-card', function() {
   var ccOptVal = $(this).attr('data-variant-id');
   ccoptionclick(ccOptVal);
   $('.packaging-prominence .variant-card.radio-active').removeClass('radio-active');
   $(this).addClass('radio-active');
 });
})();
